import Cookies from "js-cookie";

export const switchUser = (userId, token, role) => {
  const currentSession = {
    userId: Cookies.get("userId"),
    token: Cookies.get("token"),
    role: Cookies.get("role"),
  };

  Cookies.set("userId", userId);
  Cookies.set("token", token);
  Cookies.set("role", role[0]);

  let sessionStack = [];
  const storedStack = Cookies.get("sessionStack");
  if (storedStack) {
    sessionStack = JSON.parse(storedStack);
  }

  if (currentSession.userId && currentSession.token) {
    sessionStack.push(currentSession);
    Cookies.set("sessionStack", JSON.stringify(sessionStack));
  }

};

export const switchBack = () => {
  const storedStack = Cookies.get("sessionStack");

  let sessionStack = storedStack ? JSON.parse(storedStack) : [];
  const prevSession = sessionStack.pop(); 

  if (prevSession) {
    Cookies.set("userId", prevSession.userId);
    Cookies.set("token", prevSession.token);
    Cookies.set("role", prevSession.role);

    Cookies.set("sessionStack", JSON.stringify(sessionStack));
    console.log(`Switched back to user: ${prevSession.userId}`);
    return true;
  } else {
    console.log("No previous session available");
    return false;
  }
};
